<div class="ir-item-line th-filter-modal" *ngIf="inspection?.sections?.length">
  <div (click)="setOrderBy('name')" class="ir-item-cell s4 clickable">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'common.name' | translate }}
    </span>
  </div>
  <div (click)="setOrderBy('description')" class="ir-item-cell s4 clickable">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'common.description' | translate }}
    </span>
  </div>
</div>
<div
  class="ir-content-flow has-filter th-content-flow--dark has-footer"
  [ngClass]="inspection?.sections?.length ? 'has-filter' : ''"
>
  <div *ngIf="inspection">
    <div
      class="ir-item-line th-inspection clickable indent"
      [ngClass]="section.selected ? 'selected' : ''"
      (click)="selectSection(section)"
      *ngFor="let section of inspection?.sections | orderBy: orderByFieldName:direction | searchBy: query"
    >
      <div class="ir-item-cell s4">
        <div class="ir-item-selector">
          <i class="material-icons" *ngIf="!section.selected">check_box_outline_blank</i>
          <i class="material-icons" *ngIf="section.selected">check_box</i>
        </div>
        <span>{{ section.name }}</span>
      </div>
      <div class="ir-item-cell s6">
        <span *ngIf="section.description">{{ section.description }}</span>
        <span *ngIf="!section.description">{{ 'common.no-description' | translate }}</span>
      </div>
    </div>
  </div>
  <div class="ir-item-empty ir-mv8" *ngIf="inspection?.sections?.length == 0">
    <p>
      <span>{{ 'sections.no-sections' | translate }}</span>
    </p>
  </div>
</div>
